export default __webpack_public_path__ + "static/media/aave.fa995130.svg";